import React, { useState , useEffect } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import { styled } from "styled-components";

// TODO: This should be an H tag
const PTagOne = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const StyledMapContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 226px;
`;

const MainMap = ({ results, data }) => {

  function ResultsMap() {

    const [selectedDealer, setSelectedDealer] = useState(null);

    useEffect(() => {
      const listener = e => {
        if (e.key === "Escape") {
          setSelectedDealer(null);
        }
      };
      window.addEventListener("keydown", listener);

      return () => {
        window.removeEventListener("keydown", listener);
      };
    }, []);

    return (
      <GoogleMap
          defaultZoom={8}
          defaultCenter={{ lat: data.center.latitude, lng: data.center.longitude}}
        >
        {results.map((result, index) => (
            <Marker
              key={index}
              onClick={() => {
                setSelectedDealer(result);
              }}
              position={{
                lat: result.location.latitude,
                lng: result.location.longitude
              }}
            />
          ))}

        {selectedDealer &&
          <InfoWindow
            onCloseClick={() => {
              setSelectedDealer(null);
            }}
            position={{
              lat: selectedDealer.location.latitude,
              lng: selectedDealer.location.longitude
            }}
          >
            <div className="showcase-dealer-popup-info">
              <PTagOne className="showcase-dealer-profile-name">{selectedDealer.dealer.name}</PTagOne>
              <div className="showcase-dealer-profile-meta">
                <div className="showcase-dealer-profile-address">{selectedDealer.dealer.address}</div>
                <div className="showcase-dealer-profile-phone">
                  <span><a className="storelocator-phone" href={"tel:" + selectedDealer.dealer.phone}>{selectedDealer.dealer.phone}</a></span></div>
                <div className="showcase-dealer-profile-distance">{selectedDealer.distance.toFixed(2)} {data.distanceUnit && data.distanceUnit === 'km' ? 'kilometers' : 'miles'}</div>
                <div className="showcase-dealer-popup-controls">
                  <span className="showcase-dealer-profile-directions">
                    <a className="storelocator-phone" href={"https://maps.google.com?saddr=Current+Location&daddr=" + selectedDealer.dealer.address} target="_blank">Directions</a>
                  </span>
                </div>
              </div>
            </div>
          </InfoWindow>
        }
      </GoogleMap>
    );
  };

  const MapWrapped = withScriptjs(withGoogleMap(ResultsMap));

  return (
    <StyledMapContainer>
      <MapWrapped
        googleMapURL={`https://maps.googleapis.com/maps/api/js?client=gme-fendermusicalinstruments&callback=Function.prototype`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </StyledMapContainer>
  )
};

export default MainMap;
